/* tslint:disable */
/* eslint-disable */
/**
 * mama health backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FeedbackDto } from './FeedbackDto';
import {
    FeedbackDtoFromJSON,
    FeedbackDtoFromJSONTyped,
    FeedbackDtoToJSON,
} from './FeedbackDto';

/**
 * 
 * @export
 * @interface FeedbacksDto
 */
export interface FeedbacksDto {
    /**
     * 
     * @type {Array<FeedbackDto>}
     * @memberof FeedbacksDto
     */
    feedbacks: Array<FeedbackDto>;
}

/**
 * Check if a given object implements the FeedbacksDto interface.
 */
export function instanceOfFeedbacksDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "feedbacks" in value;

    return isInstance;
}

export function FeedbacksDtoFromJSON(json: any): FeedbacksDto {
    return FeedbacksDtoFromJSONTyped(json, false);
}

export function FeedbacksDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeedbacksDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'feedbacks': ((json['feedbacks'] as Array<any>).map(FeedbackDtoFromJSON)),
    };
}

export function FeedbacksDtoToJSON(value?: FeedbacksDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'feedbacks': ((value.feedbacks as Array<any>).map(FeedbackDtoToJSON)),
    };
}

